<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="display-1">Kontakty</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Contacts'
}
</script>

<style scoped>

</style>
